const o = (e) => (c) => !e.includes(c);
export {
  o as excludeProps
};
